<div class="contact-dialog" [class.rtl]="isRtl" [dir]="isRtl ? 'rtl' : 'ltr'">
  <div class="dialog-header">
    <h2>{{ 'contact.dialog.title' | translate }}</h2>
    <button mat-icon-button (click)="close()" class="close-btn" type="button">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- Topic Selection View -->
  <ng-container *ngIf="!showForm">
    <p class="dialog-subtitle">{{ 'contact.dialog.subtitle' | translate }}</p>

    <div class="topics-grid">
      @for (topic of topics; track topic.id) {
        <div
          class="topic-card"
          [class.selected]="selectedTopic?.id === topic.id"
          (click)="selectTopic(topic)"
          matRipple>
          <div class="topic-icon">
            <mat-icon>{{ topic.icon }}</mat-icon>
          </div>
          <div class="topic-content">
            <h3>{{ 'contact.topics.' + topic.id + '.title' | translate }}</h3>
            <p>{{ 'contact.topics.' + topic.id + '.description' | translate }}</p>
          </div>
          <div class="selected-indicator" *ngIf="selectedTopic?.id === topic.id">
            <mat-icon>check_circle</mat-icon>
          </div>
        </div>
      }
    </div>

    <div class="dialog-actions">
      <div class="action-buttons">
        <button mat-stroked-button (click)="close()" type="button">
          {{ 'common.cancel' | translate }}
        </button>
        <button
          mat-flat-button
          color="primary"
          [disabled]="!selectedTopic"
          (click)="showContactForm()"
          type="button">
          <mat-icon>arrow_forward</mat-icon>
          {{ 'common.continue' | translate }}
        </button>
      </div>
    </div>
  </ng-container>

  <!-- Contact Form View -->
  <ng-container *ngIf="showForm">
    <div class="form-header">
      <button mat-icon-button (click)="backToTopics()" class="back-btn" type="button">
        <mat-icon>{{ isRtl ? 'arrow_forward' : 'arrow_back' }}</mat-icon>
      </button>
      <div class="topic-badge">
        <mat-icon>{{ selectedTopic?.icon }}</mat-icon>
        <span>{{ 'contact.topics.' + selectedTopic?.id + '.title' | translate }}</span>
      </div>
    </div>

    <form [formGroup]="contactForm" class="contact-form" (ngSubmit)="sendMessage()">
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>{{ 'contact.form.name' | translate }}</mat-label>
        <mat-icon matPrefix>person</mat-icon>
        <input matInput formControlName="name" [placeholder]="'contact.form.namePlaceholder' | translate">
        <mat-error *ngIf="contactForm.get('name')?.hasError('required')">
          {{ 'validation.required' | translate }}
        </mat-error>
        <mat-error *ngIf="contactForm.get('name')?.hasError('minlength')">
          {{ 'validation.minLength' | translate: {length: 2} }}
        </mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" class="full-width">
        <mat-label>{{ 'contact.form.email' | translate }}</mat-label>
        <mat-icon matPrefix>email</mat-icon>
        <input matInput formControlName="email" type="email" [placeholder]="'contact.form.emailPlaceholder' | translate">
        <mat-error *ngIf="contactForm.get('email')?.hasError('required')">
          {{ 'validation.required' | translate }}
        </mat-error>
        <mat-error *ngIf="contactForm.get('email')?.hasError('email')">
          {{ 'common.validation.email' | translate }}
        </mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" class="full-width">
        <mat-label>{{ 'contact.form.message' | translate }}</mat-label>
        <mat-icon matPrefix>message</mat-icon>
        <textarea
          matInput
          formControlName="message"
          rows="5"
          [placeholder]="'contact.form.messagePlaceholder' | translate"></textarea>
        <mat-error *ngIf="contactForm.get('message')?.hasError('required')">
          {{ 'validation.required' | translate }}
        </mat-error>
        <mat-error *ngIf="contactForm.get('message')?.hasError('minlength')">
          {{ 'validation.minLength' | translate: {length: 10} }}
        </mat-error>
        <mat-hint align="end">{{ contactForm.get('message')?.value?.length || 0 }} / 5000</mat-hint>
      </mat-form-field>

      <div class="dialog-actions form-actions">
        <button mat-stroked-button type="button" (click)="backToTopics()" [disabled]="isLoading">
          {{ 'common.cancel' | translate }}
        </button>
        <button
          mat-flat-button
          color="primary"
          type="submit"
          [disabled]="contactForm.invalid || isLoading">
          <mat-spinner *ngIf="isLoading" diameter="20"></mat-spinner>
          <mat-icon *ngIf="!isLoading">send</mat-icon>
          {{ isLoading ? ('contact.form.sending' | translate) : ('contact.dialog.sendEmail' | translate) }}
        </button>
      </div>
    </form>
  </ng-container>
</div>
